import { downloadFeatures } from "@/mocks/home";

export default function DownloadCta() {
  return (
    <section id="download" className="scroll-mt-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="relative overflow-hidden rounded-2xl border border-primary-200 bg-primary-950 px-5 py-8 md:px-10 md:py-12">
          <div className="pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-full bg-primary-600/40 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 right-24 h-56 w-56 rounded-full bg-accent-500/20 blur-3xl" />

          <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
            <div>
              <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs tracking-wider text-background-50/90">
                <i className="ri-download-cloud-2-line" />
                新瓜提醒 · 快人一步
              </div>
              <h2 className="font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                下载客户端
                <br className="hidden md:block" />
                让新黑料网新瓜第一时间找上你
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-background-50/75">
                最新爆料秒级推送，重要事件建立专题时间线，重要更新才打扰。此处为入口示意，本轮暂不开放真实下载。
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
                <button
                  type="button"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-800 transition-colors hover:bg-accent-400 hover:text-foreground-950"
                >
                  <i className="ri-apple-fill text-base" />
                  iOS 版
                </button>
                <button
                  type="button"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-android-fill text-base" />
                  Android 版
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3">
              {downloadFeatures.map((f) => (
                <div
                  key={f.title}
                  className="rounded-xl border border-background-50/15 bg-background-50/5 p-4 backdrop-blur"
                >
                  <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                    <i className={`${f.icon} text-lg`} />
                  </span>
                  <h3 className="text-sm font-bold text-background-50">{f.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-background-50/70">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}